import "jquery-validation";
import "jquery-validation/dist/localization/messages_hu.js";
import "jquery-validation-unobtrusive";
import "cookieconsent";
import "bootstrap";
import "jquery-csv";

import autosize from "autosize";
import * as ClipboardJS from "clipboard";

import Modal from "./_bootstrapModalExtensions";
import NotificationUtil from "./_notificationUtil";

// This is the organized ts code.
// Side effects are important here, the pages can (and DO) contain jquery ready callbacks
// The page-related DX callbacks are also located here
export * from "./pages/index";

// The "old", there could be functions which are called from inline HTML, so they are directly exported here
export * from "./RD";

export * from "./DxGridFunctions/AddresseeList";
export * from "./DxGridFunctions/DocumentList";
export * from "./DxGridFunctions/HandleDXCallbackError";
export * from "./DxGridFunctions/MassTransfer";
export * from "./DxGridFunctions/ProcessActionList";
export * from "./DxGridFunctions/ProcessList";
export * from "./DxGridFunctions/Tag";
export * from "./DxGridFunctions/Helpers";

export * from "./Intros/_addRelatedProcess";
export * from "./Intros/_IntroBase";
export * from "./Intros/_partnerTab";
export * from "./Intros/_settlementFilter";

export * from "./popovers/_popover";

// Utils should not be exported
 
export * from "./_address";
//export * from "./_api";
export * from "./_autocomplete";
export * from "./_bootstrapAlertMessage";
export * from "./_bootstrapModalExtensions";
export * from "./_dateFilterPanel";
export * from "./_datepicker";
export * from "./_devexpressFilter";
export * from "./_documentList";
export * from "./_documentTag";
export * from "./_dxRichEdit";
export * from "./_editErintettPartner";
export * from "./_editKamara";
export * from "./_ekeidr";
export * from "./_expertUserRegistration";
export * from "./_filingEdit";
export * from "./_filingList";
export * from "./_footer";
export * from "./_google_analytics";
export * from "./_helpers";
export * from "./_heritageRegister";
export * from "./_interfaces";
export * from "./_layout";
export * from "./_limesurvey";
export * from "./_notices";
export * from "./_notificationUtil";
export * from "./_office";
export * from "./_processAction";
export * from "./_processEdit";
export * from "./_processEstate";
export * from "./_processList";
export * from "./_processListForProcessSelect";
export * from "./_processShare";
export * from "./_rdCitizen";
export * from "./_secondary-menu";
export * from "./_selectErintettOffice";
export * from "./_settings_manager";
export * from "./_sticky-kit";
export * from "./_systemAdmin";
export * from "./_takarnet";
export * from "./_template";
export * from "./_transferUser";
export * from "./_upload-dropzone";
export * from "./Feedback";
export * from "./_contactsupport";

declare global {
    interface Window {
        StyleMedia: any;
    }
}

export function promptGDPR() {
    if (window.ETDR_RD.appConfig["User.IsCurrentUserAvailable"]) {
        if (!window.ETDR_RD.appConfig["User.IsGDPRAccepted"]) {
            let contentUrl = window.ETDR_RD.appConfig["UrlAction.GetGDPRTerms"];
            let acceptUrl = window.ETDR_RD.appConfig["UrlAction.AcceptGDPRTerms"];

            $.get(contentUrl, null, (data, status) => {
                Modal.showAlertWindow(data as string, 'Adatvédelmi tájékoztató', 'A feltételeket megértettem és elfogadom', false, b => {
                    $.post(acceptUrl);
                });
            });
        }
    }
}

// Helper function to determine whether the input is "Set to true"
// It supports checkbox input and hidden inputs
// Checkbox is "truthy" when checked, hidden is "truthy" when the value is "True"
// This function is used when the input is one of the supported input types. In special cases, a checkbox should be disabled
// Sadly, disabled checkboxes are not a thing, so a fake checkbox and a hidden input field is used
export function isInputValueTrue($input) {
    if ($input.attr('type') === 'hidden') {
        return $input.val() === 'True' || $input.val() === 'true';
    }
    else {
        return $input.is(':checked');
    }
}

export function initInputFilter() {
    $('body').on("keydown", "input[data-filter-input-numeric-only]", e => {
        // Allow: Delete, Backspace, Tab, Escape, Enter
        if ($.inArray(e.keyCode, [46, 8, 9, 27, 13]) !== -1
            // Allow: Ctrl+A, Command+A
            || (e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true))
            // Allow: home, end, left, right, down, up
            || (e.keyCode >= 35 && e.keyCode <= 40)) {
            // let it happen, don't do anything
            return;
        }

        // Ensure that it is a number and stop the keypress if not
        if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
            e.preventDefault();
        }
    });
}

// Helper function to handle the click event in specific columns (in a DX table)
// Gets the usual OnRowClick event handler parameters and the click event handler (the callback parameter, a "normal" event handler)
export function OnCellClickHelper(s: MVCxClientGridView, e: ASPxClientGridViewRowClickEventArgs, callback: (s: ASPxClientGridView, e: ASPxClientGridViewRowClickEventArgs) => void) {
    let target = e.htmlEvent.target as HTMLElement;
    let td = target.closest('td');

    if (td && td.classList.contains('cell-clickable')) {
        callback(s, e);
    }
}

export function StretchDXGridViewToContainerHeight(s: MVCxClientGridView, e: ASPxClientEventArgs) {
    let parentHeight = $('#' + s.name).parent().height();
    s.SetHeight(parentHeight);
}

jQuery(() => {
    window.ETDR_RD.init();

    initInputFilter();

    autosize($('textarea.auto-expand'));

    var clipboard = new ClipboardJS('.clipboard');
    clipboard.on('success', _ => {
        NotificationUtil.Success('A másolás sikeresen megtörtént!', 'Siker');
    });

    promptGDPR();

    $('.dropdown-bs4-stop-close-on-click-inside').on('hide.bs.dropdown', (event: Bootstrap.DropdownsEventHandler<HTMLElement>) => {
        let clickEvent = (event as any).clickEvent as JQuery.ClickEvent;

        // Documentation: event.clickEvent is only present if the triggering event is a click
        // Reality: event.clickEvent is always present, event.clickEvent.originalEvent is present if the original event is a click
        if (clickEvent && clickEvent.originalEvent) {
            let target = $(clickEvent.target);
            return !(target.hasClass("dropdown-bs4-stop-close-on-click-inside") || target.parents(".dropdown-bs4-stop-close-on-click-inside").length);
        }
    });
});
